/* =========================================================
   HOME DECORE — Sliders & Carousels
   ========================================================= */
(function () {
  'use strict';

  /* ---------------- Hero slider ---------------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.from(root.querySelectorAll('.hero-slide'));
    var dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var timer;

    if (slides.length <= 1) return;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      resetTimer();
    }

    function resetTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    root.querySelectorAll('[data-hero-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(current - 1); });
    });
    root.querySelectorAll('[data-hero-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(current + 1); });
    });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });

    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) goTo(current + (diff < 0 ? 1 : -1));
    }, { passive: true });

    resetTimer();
  });

  /* ---------------- Announcement bar slider ---------------- */
  document.querySelectorAll('[data-announcement-bar]').forEach(function (root) {
    var slides = Array.from(root.querySelectorAll('.announcement-bar__slide'));
    if (slides.length <= 1) return;
    var current = 0;
    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 4500);
  });

  /* ---------------- Generic carousel (product carousel, reviews) ---------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var viewport = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!viewport || !track) return;

    function getStep() {
      var firstItem = track.children[0];
      if (!firstItem) return 0;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap || style.columnGap || 24);
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = viewport.scrollLeft <= 4;
      nextBtn.disabled = viewport.scrollLeft >= (track.scrollWidth - viewport.clientWidth - 4);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    viewport.style.overflowX = 'auto';
    viewport.style.scrollSnapType = 'x mandatory';
    Array.from(track.children).forEach(function (child) { child.style.scrollSnapAlign = 'start'; });
    viewport.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });

  /* ---------------- Video banner sound toggle ---------------- */
  document.querySelectorAll('[data-video-banner]').forEach(function (root) {
    var video = root.querySelector('video');
    var toggle = root.querySelector('[data-sound-toggle]');
    if (!video || !toggle) return;
    toggle.addEventListener('click', function () {
      video.muted = !video.muted;
      toggle.classList.toggle('is-muted', video.muted);
    });
  });

  /* ---------------- Recently viewed (localStorage tracking) ---------------- */
  (function trackRecentlyViewed() {
    var pdpData = document.querySelector('[data-current-product]');
    if (!pdpData) return;
    try {
      var handle = pdpData.getAttribute('data-current-product');
      var key = 'homedecore_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 12);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  })();

  document.querySelectorAll('[data-recently-viewed]').forEach(function (root) {
    try {
      var key = 'homedecore_recently_viewed';
      var currentHandle = root.getAttribute('data-exclude-handle');
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== currentHandle; });
      if (!list.length) { root.closest('[data-recently-viewed-section]')?.setAttribute('hidden', ''); return; }

      var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
      list = list.slice(0, limit);

      Promise.all(list.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) { root.closest('[data-recently-viewed-section]')?.setAttribute('hidden', ''); return; }
        root.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]);
          var price = (window.HomeDecore && window.HomeDecore.formatMoney)
            ? window.HomeDecore.formatMoney(p.price)
            : ((window.themeSettings && window.themeSettings.moneyFormat) || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (p.price / 100).toFixed(2));
          return '<a href="' + p.url + '" class="product-card">' +
            '<div class="product-card__media ratio-box ratio-' + (window.themeSettings.productImageRatio || 'tall') + '">' +
              '<img src="' + img + '" loading="lazy" alt="' + p.title.replace(/"/g, '&quot;') + '" width="400" height="500">' +
            '</div>' +
            '<div class="product-card__info">' +
              '<p class="product-card__vendor">' + p.vendor + '</p>' +
              '<h3 class="product-card__title">' + p.title + '</h3>' +
              '<div class="product-card__price">' + price + '</div>' +
            '</div>' +
          '</a>';
        }).join('');
      });
    } catch (e) { /* noop */ }
  });
})();
